import { motion } from "framer-motion";

const items = [
  {
    n: "01",
    title: "The gentle entrepreneur",
    body: "Building a business without the burnout. You want AI to run the tedious 60% so you can focus on brand, taste, and craft.",
  },
  {
    n: "02",
    title: "The creative professional",
    body: "A writer, designer, coach, or creator who suspects AI could 5× your output — if only someone showed you the elegant way in.",
  },
  {
    n: "03",
    title: "The soft-life seeker",
    body: "You are done hustling. You want systems, automations, and delegated tasks. You want your life to feel like a Sunday morning.",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 1.2, ease: [0.16, 1, 0.3, 1], delay: i * 0.15 },
  }),
};

export default function WhoThisIsFor() {
  return (
    <section
      id="who"
      data-testid="who-section"
      className="py-24 md:py-40 px-6 md:px-12 lg:px-20"
      style={{ background: "#FAF9F6" }}
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
          className="md:col-span-5"
        >
          <span className="overline" data-testid="who-overline">Who this is for</span>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl mt-6 leading-[1.05]">
            For women who suspect there is a <em>softer</em>, smarter way.
          </h2>
          <div className="gold-hair mt-8" />
          <p className="mt-8 max-w-md text-[15px] md:text-base leading-relaxed text-[#5C5A56]">
            Findaura is not another tech bro course. It's a quiet, editorial approach to
            AI — tools, prompts, and delegated workflows built for the way we actually live.
          </p>
        </motion.div>

        <div className="md:col-span-7 grid grid-cols-1 gap-6">
          {items.map((item, i) => (
            <motion.article
              key={item.n}
              custom={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              className="card-luxe grid grid-cols-12 gap-6 items-start"
              data-testid={`who-card-${item.n}`}
            >
              <div className="col-span-2">
                <span className="font-serif italic text-3xl md:text-4xl text-[#C28C55]">{item.n}</span>
              </div>
              <div className="col-span-10">
                <h3 className="font-serif text-2xl md:text-3xl font-light">{item.title}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-[#5C5A56]">{item.body}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
